var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length)?_c('div',{staticClass:"errors bg-light-red text-red border-radius-15 p-2 mb-2"},[_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(error){return _c('li',{key:error},[_vm._v(_vm._s(error))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }